<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="8">
        <el-card style="margin-top: 15px">
          <el-row class="title_row">
            <el-col :span="12">
              <span class="title_class">裁判功能</span>
            </el-col>
          </el-row>
          <el-button type="primary" plain icon="el-icon-link" @click="copy">大屏排名链接</el-button>
          <el-button type="primary" plain icon="el-icon-download" @click="exportTable">导出裁判系统</el-button>
        </el-card>
      </el-col>
      <el-col :span="16">
        <!-- 筛选 -->
        <el-card style="margin-top: 15px">
          <el-row class="title_row">
            <el-col>
              <span class="title_class">筛选</span>
            </el-col>
          </el-row>
          <el-form
            :model="queryForm"
            class="filter_Form"
            label-width="90px"
            ref="queryFormRef"
          >
            <el-row>
              <el-col :span="12">
                <el-form-item label="赛季" prop="season" style="margin-bottom: 0;">
                  <el-select
                    placeholder="请选择"
                    style="width: 100%"
                    v-model="queryForm.season"
                    @change="getDataList"
                  >
                    <el-option
                      v-for="item in dict_season"
                      :key="item.dictValue"
                      :label="item.dictLabel"
                      :value="item.dictValue"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="flag === '1-C-1'">
                <el-form-item label="组别" prop="level" style="margin-bottom: 0;">
                  <el-select
                    placeholder="请选择类型"
                    style="width: 100%"
                    v-model="queryForm.level"
                    @change="getDataList"
                  >
                    <el-option
                      v-for="item in dict_group"
                      :key="item.dictCode"
                      :label="item.dictLabel"
                      :value="item.dictCode"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
    <el-card style="margin-top: 15px;">
      <template v-if="queryForm.level || queryForm.isGroup === 2">
        <el-row class="title_row">
          <el-col :span="12">
            <span class="title_class">选手列表<i class="refresh" :class="loading ? 'el-icon-loading' : 'el-icon-refresh'" @click="getDataList"></i></span>
          </el-col>
          <!-- <el-col :span="12" style="text-align: right;">
            <el-button
              type="primary"
              @click="exportTable()"
              >导出裁判系统</el-button
            >
          </el-col> -->
        </el-row>
        <el-table
          header-cell-class-name="tableHeaderStyle"
          :data="dataList"
          border
          stripe
        >
          <el-table-column label="序号" type="index" width="50px"></el-table-column>
          <el-table-column label="姓名" prop="userName"></el-table-column>
          <el-table-column label="手机号" prop="phone"></el-table-column>
          <el-table-column label="学校" prop="schoolName"></el-table-column>
          <el-table-column label="年级" prop="grade" :formatter="gradeFormatter"></el-table-column>
          <el-table-column label="比赛号码牌" prop="matchNum">
            <template slot-scope="scope">
              <span class="num num1">{{ addZero(scope.row.matchNum) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="抽签顺序号" prop="raceNumber">
            <template slot-scope="scope">
              <span class="num">{{ addZero(scope.row.raceNumber) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="设置名次" prop="rank">
            <template slot-scope="scope">
              <el-select v-model="scope.row.rank"
                style="width: 100px;"
                placeholder="请选择名次"
                @change="changeRank(scope.row)">
                <el-option
                  v-for="item in rankSel"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="晋级状态" prop="groupPromote" width="100px">
            <template slot-scope="scope">
              <el-select v-model="scope.row.groupPromote" @change="promoteChange(scope.row)" size="small" :class="'promote' + scope.row.groupPromote">
                <el-option
                  v-for="item in pList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <div class="default" v-else>
        <el-empty description="请选择组别"></el-empty>
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  name: 'groupC',
  props: {
    flag: {
      Type: String,
      default: 0
    }
  },
  data () {
    return {
      dict_group: this.$userInfo.dict_group(), // 组别下拉列表
      dict_season: this.$userInfo.getDataList(this, 't_season').then(value => { this.dict_season = value }), // 赛季下拉列表
      dict_grade: this.$userInfo.getGradeData(), // 年级
      queryForm: {
        activityType: this.$chnEngStatusCode.activityType,
        season: this.$chnEngStatusCode.defaultSeason,
        // round: 5,
        level: 1,
        isGroup: Number(this.$route.query.group)
      },
      dataList: [],
      loading: false,
      pList: [
        { label: '晋级', value: 1 },
        { label: '淘汰', value: 0 },
        { label: '未设置', value: -1 }
      ]
    }
  },

  methods: {
    init1C () {
      // this.getDataList()
      this.queryForm.level = ''
      this.dataList = []
    },
    init2B () {
      this.queryForm.level = ''
      this.dataList = []
      this.getDataList()
    },
    getDataList () {
      this.loading = true
      this.$http.get('/national/queryNationalGroupList', { params: { ...this.queryForm, ...{ round: this.queryForm.isGroup === 1 ? 9 : 8 } } }).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.dataList = res.data
          this.dataList.forEach(item => {
            item.rank = this.queryForm.isGroup === 1 ? item.groupRank : item.drawRank
          })
          const rankSel = []
          for (var i = 0; i < res.data.length; i++) {
            rankSel.push(i + 1)
          }
          this.rankSel = rankSel
        }
      })
    },
    promoteChange (item) {
      console.log(item)
      this.$http.post('national/updateGroupThreePromote', {
        groupTwoPromote: item.groupPromote,
        nationalId: item.nationalId
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('修改成功')
        }
      })
    },
    changeRank (item) {
      console.log(item)
      this.$http.post('/national/setNationalGroupCRank', {
        id: item.nationalId,
        rank: item.rank,
        isGroup: this.queryForm.isGroup
      }).then(res => {
        if (res.code === 200) {
          this.getDataList()
        }
      })
    },
    exportTable () {
      const downLoadUrl = `${this.$http.defaults.baseURL}national/excelNationalGroupList?${this.$xcUtils.serialize(this.queryForm)}`
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl)
    },
    gradeFormatter (data) {
      return data.grade ? this.dict_grade.find(item => item.dictCode === data.grade).dictLabel : '--'
    },
    levelFormatter (data) {
      return data.level ? this.dict_group.find(item => item.dictCode === data.level).dictLabel : '--'
    },
    addZero (num) {
      return this.$xcUtils.addZero(num)
    },
    copy () {
      if (!this.queryForm.season) {
        return this.$message.warning('请选择赛季')
      }
      if (this.queryForm.isGroup === 1 && !this.queryForm.level) {
        return this.$message.warning('请选择组别')
      }
      var input = document.createElement('input') // 创建input标签
      var loc = window.location.origin
      const query = {
        activityType: this.queryForm.activityType,
        season: this.queryForm.season,
        level: this.queryForm.level,
        group: this.queryForm.isGroup,
        round: this.queryForm.isGroup === 1 ? 'C' : 'B'
      }
      input.value = `${loc}/#/pad/rank?${this.$xcUtils.serialize(query)}` // 将input的值设置为需要复制的内容
      document.body.appendChild(input) // 添加input标签
      input.select() // 选中input标签
      document.execCommand('copy') // 执行复制
      this.$message.success('复制成功') // 成功提示信息
      document.body.removeChild(input) // 移除input标签
    }
  }
}
</script>
<style lang="less" scoped>
.num {
  font-size: 18px;
  font-weight: bold;
  color: #409EFF;
}
.num1{
  color: #000;
}
.refresh{
  color: #409EFF;
  cursor: pointer;
  margin-left: 12px;
}
/deep/ .promote1 .el-input__inner {
  background: #67C23A;
  color: #fff;
}
/deep/ .promote0 .el-input__inner {
  background: #F56C6C;
  color: #fff;
}
</style>
